import moment from 'moment';
import 'moment/locale/pt-br';
moment.locale('pt-br');
export const monthNames = [
    'Jan',
    'Fev',
    'Mar',
    'Abr',
    'Mai',
    'Jun',
    'Jul',
    'Ago',
    'Set',
    'Out',
    'Nov',
    'Dez',
];
export const weekdayNames = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
export const formatDate = (date) => {
    if (!date)
        return '';
    const weekday = weekdayNames[date.getDay()];
    const day = date.getDate().toString().padStart(2, '0');
    const month = monthNames[date.getMonth()];
    return `${weekday}, ${day} ${month}`;
};
export const formatDateWithDay = (date) => {
    const formattedDate = moment(date).format('ddd, DD MMM');
    return formattedDate.replace(/\b\w/g, (char) => char.toUpperCase());
};
//# sourceMappingURL=FormatDate.js.map